<template>
    <div class="login-view">
        <div class="card">
			<div class="card-body">
				<div class="m-sm-4">
                    <p class="lead text-center">
                        
                    </p>
                    <div class="text-center">
                        <img src="@/assets/img/auulogo.png" alt="auu alient" class="img-fluid" width="132" height="132">
                        <h3>鎂鉑數位隱形矯正</h3>
                        <small>歡迎使用鎂鉑數位隱形矯正</small>
                    </div>
					<form class="text-start">
                        <div class="form-group mb-3">
                            <label class="form-label">帳號</label>
                            <input 
                                class="form-control error form-control-lg" 
                                type="email" 
                                name="email" 
                                :class="{'error':inputForm.email.error}"
                                :placeholder="inputForm.email.placeholder"
                                v-model="inputForm.email.value"
                            >
                        </div>
                        <div class="form-group password-group">
                            <label class="form-label">密碼</label>
                            <input 
                                class="form-control form-control-lg" 
                                :type="passwordInputType" 
                                name="password" 
                                :class="{'error':inputForm.password.error}"
                                :placeholder="inputForm.password.placeholder"
                                v-model="inputForm.password.value"
                            >
                            <i class="align-middle me-2 fas fa-fw"
                                :class="[{'fa-eye-slash':!passwordShow},{'fa-eye':passwordShow}]"
                                @click="()=> { this.passwordShow = !this.passwordShow }"
                            ></i>
                        </div>
                        <!-- <div>
                            <div class="custom-control custom-checkbox align-items-center">
                                <input id="customControlInline" type="checkbox" class="custom-control-input me-2" value="remember-me" name="remember-me" checked="">
                                <label class="custom-control-label text-small" for="customControlInline">記住我</label>
                            </div>
                        </div> -->
                        <div class="text-center mt-3">
                            <button type="button"
                                class="btn btn-lg btn-primary"
                                @click="loginHandle"
                            >登入</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CryptoJS from "crypto-js";
export default {
    name: 'LoginView',
    data(){
        return {
            passwordShow:false,
            inputForm:{
                email:{
                    value:'',
                    error:false,
                    placeholder:'請輸入email帳號'
                },
                password:{
                    value:'',
                    error:false,
                    placeholder:'請輸入密碼'
                }
            },
        }
    },
    components: {
      
    },
    computed:{
        passwordInputType(){
            return this.passwordShow ? 'text' : 'password'
        }
    },
    methods:{
        checkInput(){
            let check = true
            if ( this.inputForm.email.value.trim() == "" ){
                this.inputForm.email.error = true
                check = false
            }
            let emailRegxp = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
            if ( emailRegxp.test(this.inputForm.email.value.trim()) == false ){
                this.inputForm.email.error = true
                this.inputForm.email.placeholder = '*請輸入Email格式'
                check = false
            }
            if ( this.inputForm.password.value.trim() == "" ){
                this.inputForm.password.error = true
                check = false
            }
            return check
        },
        async loginHandle(){

            if ( !this.checkInput() ){
                return
            }

            this.$store.state.loadingStatus = true

            let objFrom = new FormData()

            objFrom.append('email',this.inputForm.email.value)
            objFrom.append('password', CryptoJS.MD5(this.inputForm.password.value).toString())

            const res = await this.$api.login(objFrom)
            this.$store.state.loadingStatus = false
            alert(res.showmsg)
            if ( res.code !== 200 ){
                return
            }
            //處理登入資訊
            localStorage.setItem('auu_user_info',JSON.stringify(res.data))
            this.$api.init({token:res.data.token})

            console.log(this.$api.header)

            this.$store.state.loginStatus = true

            //處理如果是從his系統來，那就轉進去his重新導向
            const hisRedirection = localStorage.getItem('hisRedirection') ? JSON.parse(localStorage.getItem('hisRedirection')) : null
            if ( hisRedirection && hisRedirection.name == 'his' ){
                localStorage.removeItem('hisRedirection')
                this.$router.push(hisRedirection.href)
                return    
            }
            
            this.$router.push({name:'board-index'})
            
        }
    },
    created(){
        if ( localStorage.getItem('auu_user_info') ){
            localStorage.removeItem('auu_user_info')
            this.$api.header = {}
            this.$store.state.loginStatus = false
        }
    }
}
</script>
<style scoped>
.login-view{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 使 ::before 绝对定位相对于这个容器 */
}
.login-view::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4); /* 白色半透明，調整 alpha 值以改變壓淡程度 */
    z-index: 1; /* 讓遮罩在背景圖片上 */
}

.content {
    position: relative; /* 使内容在遮罩之上 */
    z-index: 2;
}
.login-view > .card {
    min-width: 576px;
    max-width: 576px;
    height: fit-content;
    z-index:2;
}
.img-fluid{
    background-color: #f4f7fc;
}
.password-group{
    position: relative;
}
.password-group > i{
    position: absolute;
    bottom: 12px;
    right: 10px;
    cursor: pointer;
}
@media (max-width: 768px) {
    .login-view > .card{
        min-width: 90%;
    }
    .form-control{

    }
}

</style>
  